import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: "click",
		};
	}

	init() {}

	click() {
		let text = this.getData("text");
		navigator.clipboard.writeText(text);

		window.alert("Copied to clipboard");
	}

	destroy() {}
}
